import React from 'react';
import Header from '../components/header';
import {
  Container,
  Grid,
  TextField,
  Button,
  Typography,
  Card,
  CardContent,
  Box,
  Avatar,
  Link
} from '@mui/material';
import { FaFacebook, FaInstagram } from "react-icons/fa";
import '../styles/contacto.css';
import { useLanguage } from '../context/LanguageContext';

const Contacto = () => {
  const { language } = useLanguage();

  const content = {
    es: {
      eyebrow: 'Conecta con nuestro equipo',
      title: 'Contactanos',
      subtitle: '¿Tienes preguntas o necesitas mas informacion? Escribenos y te responderemos lo antes posible.',
      location: 'Ubicacion',
      phone: 'Telefono',
      email: 'Correo electronico',
      emailStatus: 'Formulario web habilitado',
      formTitle: 'Envianos tu mensaje',
      name: 'Nombre',
      mail: 'Correo',
      message: 'Mensaje',
      send: 'Enviar'
    },
    en: {
      eyebrow: 'Connect with our team',
      title: 'Contact Us',
      subtitle: 'Do you have questions or need more information? Send us a message and we will reply as soon as possible.',
      location: 'Location',
      phone: 'Phone',
      email: 'Email',
      emailStatus: 'Web form enabled',
      formTitle: 'Send us your message',
      name: 'Name',
      mail: 'Email',
      message: 'Message',
      send: 'Send'
    }
  };

  const t = content[language];

  return (
    <Box className="contacto-container page-shell">
      <Header />
      <Container maxWidth="lg">
        <Box textAlign="center" sx={{ mb: 5 }}>
          <Typography className="section-eyebrow">{t.eyebrow}</Typography>
          <Typography variant="h4" className="contacto-title">
            {t.title}
          </Typography>
          <Typography variant="body1" className="contacto-subtitle">
            {t.subtitle}
          </Typography>
        </Box>
        <hr className="beneficios-separator" />
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Card className="contact-card info-card" sx={{ p: 3, borderRadius: '20px' }}>
              <CardContent>
                <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                  <Avatar className="contact-avatar" sx={{ mr: 2 }}>📍</Avatar>
                  <Box>
                    <Typography variant="h6">{t.location}</Typography>
                    <Typography variant="body2">Loja, Ecuador</Typography>
                  </Box>
                </Box>
                <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                  <Avatar className="contact-avatar" sx={{ mr: 2 }}>📞</Avatar>
                  <Box>
                    <Typography variant="h6">{t.phone}</Typography>
                    <Typography variant="body2">+593 98 815 6009</Typography>
                  </Box>
                </Box>
                <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                  <Avatar className="contact-avatar" sx={{ mr: 2 }}>📧</Avatar>
                  <Box>
                    <Typography variant="h6">{t.email}</Typography>
                    <Typography variant="body2">{t.emailStatus}</Typography>
                  </Box>
                </Box>
                <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                  <Avatar className="contact-avatar" sx={{ mr: 2 }}><FaFacebook /></Avatar>
                  <Box>
                    <Typography variant="h6">Facebook</Typography>
                    <Link href="https://www.facebook.com/sainza.altonangaritza/" target="_blank" color="inherit" underline="none">
                      SainzaEcuador
                    </Link>
                  </Box>
                </Box>
                <Box display="flex" alignItems="center">
                  <Avatar className="contact-avatar" sx={{ mr: 2 }}><FaInstagram /></Avatar>
                  <Box>
                    <Typography variant="h6">Instagram</Typography>
                    <Link href="https://www.instagram.com/sainza.altonangaritza/" target="_blank" color="inherit" underline="none">
                      @SainzaEcuador
                    </Link>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card className="contact-card form-card" sx={{ p: 3, borderRadius: '20px', height: '100%' }}>
              <CardContent>
                <Typography variant="h6" className="form-title">{t.formTitle}</Typography>
                <form action="https://api.web3forms.com/submit" method="POST">
                  <input type="hidden" name="access_key" value="c27ddbd6-f2d8-4659-affb-31c3cd0f4d2b" />
                  <TextField
                    className="contact-input"
                    fullWidth
                    name="Nombre"
                    label={t.name}
                    required
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    className="contact-input"
                    fullWidth
                    name="Email"
                    label={t.mail}
                    type="email"
                    required
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    className="contact-input"
                    fullWidth
                    name="Telefono"
                    label={t.phone}
                    type="tel"
                    required
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    className="contact-input"
                    fullWidth
                    name="Mensaje"
                    label={t.message}
                    multiline
                    rows={4}
                    required
                    margin="normal"
                    variant="outlined"
                  />
                  <Box textAlign="center" sx={{ mt: 2 }}>
                    <Button
                      className="contact-submit"
                      type="submit"
                      variant="contained"
                      sx={{ px: 4, py: 1.2 }}
                    >
                      {t.send} &rarr;
                    </Button>
                  </Box>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Contacto;
